import { render, staticRenderFns } from "./GymRegister.vue?vue&type=template&id=4da57957"
import script from "./GymRegister.vue?vue&type=script&lang=js"
export * from "./GymRegister.vue?vue&type=script&lang=js"
import style0 from "./GymRegister.vue?vue&type=style&index=0&id=4da57957&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports